
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Die Natur hält dafür eine grosse Apotheke bereit. Zu beachten ist allerdings, dass nicht nur chemische, sondern auch natürliche Ingredienzien über eine hohe Potenz und somit eine starke Wirkung verfügen. Darum sollten auch pflanzliche Mittel sorgfältig verwendet werden, auch dann, wenn man sie ohne Rezept bekommt. Eine gute Wirkung wird Baldrian, Lavendel, Hopfen, Melisse und Passionsblumen nachgesagt. Pflanzliche Medikamente stören den natürlichen Ablauf der Schlafphasen nicht und haben auch selten Nebenwirkungen. Sollten die Schlafbeschwerden länger anhalten, sollte man sich fachliche Hilfe holen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;